import { useQuery } from "@apollo/client/react";
import GET_USER_GROUPS from "../../queries/rolesAndPermissions/getUserGroups";
import type { SkynetUserGroup } from "../../../models/RolesAndPermissionsModels";
import type { SortDirection } from "../../../models/SortDirection";

export const useUserGroups = (
  searchTerm?: string,
  sortDirection?: SortDirection,
  skip?: number,
  take?: number,
) => {
  const { data, error, loading, refetch } = useQuery<{
    userGroups: { totalCount: number; items: Array<SkynetUserGroup> };
  }>(GET_USER_GROUPS, {
    variables: {
      searchTerm,
      sortDirection,
      skip,
      take,
    },
    fetchPolicy: "cache-and-network",
  });
  return { userGroups: data?.userGroups, error, loading, refetch };
};
